// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4.39 6.66L5.6 5.45C6.14 4.91 7.03 4.91 7.58 5.45L8 5.88C8.2 6.07 8.51 6.07 8.71 5.88L11.18 3.4C11.57 3.01 12.21 3.01 12.6 3.4C12.99 3.79 12.99 4.43 12.6 4.82L10.12 7.29C9.93 7.49 9.93 7.8 10.12 8L10.55 8.42C11.09 8.97 11.09 9.86 10.55 10.4L9.34 11.61Z',
  'M4.25 6.8C3.17 7.81 2.24 8.11 1.28 8.49C0.99 8.62 0.93 8.99 1.15 9.21L5.1 13.16C5.95 14.01 7.54 13.41 9.2 11.75',
];
